import declare from "dojo/_base/declare";
import _ from "lodash";
import MultiActionPopupMixin from "csi/action/MultiActionPopupMixin";
import ProductHierarchyFoodNewCopyParams from "src/SiteAdmin/ProductHierarchy/ProductHierarchyFoodNewCopyParams";
import NewFrom from "csi/table/NewFrom";
import def from "csi/def";

const ProductHierarchyNewFromFood = declare([NewFrom, MultiActionPopupMixin, ProductHierarchyFoodNewCopyParams], {
	// Dialog localization strings
	loadingMessageTemplateSingular: "MultiCopyFood_LoadingSingular",
	loadingMessageTemplatePlural: "MultiCopyFood_LoadingPlural",
	successMessageTemplateSingular: "MultiCopyFood_SuccessSingular",
	successMessageTemplatePlural: "MultiCopyFood_SuccessPlural",

	// String: name of field containing number of nodes to create
	numCreateField: "NumToCreate",

	/**
	 * @override
	 * Disable Save&Go button for NewFromFood action
	 * @returns boolean for if button should be displayed
	 */
	_canNavigate: function () {
		return def.canNavigateToType(this.m_typeNode) && !this.widget.bPopup;
	},
});

export = ProductHierarchyNewFromFood;